import React from "react";
import FancyThanks from "@/components/FancyThanks";

/**
 * v1.25.52 — Full-screen "INBOX ZERO" celebration. Uses the same premium
 * pixabay-style shards+3D-text overlay as ThanksOverlay so every celebration
 * across the app feels consistent — just with an amber palette instead of gold.
 */
export default function InboxZeroOverlay({ open, onClose }) {
    return (
        <FancyThanks
            open={open}
            onClose={onClose}
            title="INBOX ZERO"
            subtitle="Every pending slip has been handled — enjoy the calm."
            caption="You just cleared the entire verification queue. Nicely done."
            ctaLabel="Keep going"
            palette="amber"
            testId="inbox-zero-overlay"
        />
    );
}
